import { render, staticRenderFns } from "./navigtor.vue?vue&type=template&id=1cccbfaa&scoped=true"
import script from "./navigtor.vue?vue&type=script&lang=js"
export * from "./navigtor.vue?vue&type=script&lang=js"
import style0 from "./navigtor.vue?vue&type=style&index=0&id=1cccbfaa&prod&scoped=true&lang=less"
import style1 from "./navigtor.vue?vue&type=style&index=1&id=1cccbfaa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cccbfaa",
  null
  
)

export default component.exports